import styled from 'styled-components'

import { Color } from 'root-constants'

const BaseText = styled.p`
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  color: ${Color.INK_DARKEST};
`

export const StyledSelectGenderAyah = {
  Container: styled.div`
    max-width: 375px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 16px 24px 0;
    margin: 0 auto;
  `,
  Title: styled.h1<{ $isSmall?: boolean }>`
    font-size: ${({ $isSmall }) => ($isSmall ? '24px' : '32px')};
    line-height: ${({ $isSmall }) => ($isSmall ? '32px' : '36px')};
    margin-bottom: ${({ $isSmall }) => ($isSmall ? '16px' : '8px')};

    font-weight: 700;
    text-align: center;
    color: ${Color.INK_DARKEST};

    & strong {
      color: ${Color.BLUE_DARKER};
    }
  `,
  TitleVariation: styled.h1`
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin-bottom: 12px;
  `,
  SubtitleVariation: styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: center;
    color: ${Color.INK_LIGHT};
  `,
  Subtitle: styled.p<{ $isRegular?: boolean; $isSmall?: boolean }>`
    font-size: ${({ $isRegular, $isSmall }) => {
      if ($isSmall) return '12px'
      return $isRegular ? '18px' : '20px'
    }};
    line-height: ${({ $isSmall }) => ($isSmall ? '16px' : '24px')};
    text-transform: ${({ $isSmall }) => ($isSmall ? 'uppercase' : 'none')};
    font-weight: ${({ $isRegular }) => ($isRegular ? 400 : 700)};
    text-align: center;
    color: ${({ $isRegular }) =>
      $isRegular ? Color.INK_BASE : Color.INK_DARKEST};
  `,
  Note: styled(BaseText)`
    margin-bottom: 24px;
  `,
  CardsContainer: styled.div`
    width: 100%;
    height: 295px;
    display: flex;
    flex-direction: row;
    gap: 12px;

    margin: 24px 0;
  `,
  TermsNote: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    padding: 24px 0;
  `,
}
